import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion, useReducedMotion } from 'motion/react'
import { trackPageView, trackButtonClick } from '../services/analyticsService'

const LOGO = '/spa-images/logo white -trademark-small.png'
const HERO = '/spaces/deck1.png'
const STRIP = ['/spaces/deck2.png', '/spaces/deck5.png', '/spaces/deck6.png']

function HomePage() {
  const navigate = useNavigate()
  const reduce = useReducedMotion()

  useEffect(() => {
    trackPageView('home')
  }, [])

  const handleGetStarted = () => {
    trackButtonClick('Get Started', 'home_hero')
    navigate('/visualizer')
  }

  const rise = (delay: number) =>
    reduce
      ? {}
      : {
          initial: { opacity: 0, y: 16 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] as const },
        }

  return (
    <div className="home">
      <header className="home__bar">
        <span className="wordmark" style={{ cursor: 'default' }}>
          <img src={LOGO} alt="Portable Spas NZ" />
          <span className="wordmark__name">AquaVision</span>
        </span>
        <a className="home__bar-link" href="https://portablespas.co.nz" target="_blank" rel="noopener noreferrer">
          portablespas.co.nz
        </a>
      </header>

      <main className="home__main">
        <div className="home__copy">
          <motion.p className="home__eyebrow" {...rise(0)}>
            Free AI spa visualiser
          </motion.p>
          <motion.h1 className="home__title" {...rise(0.08)}>
            See it in your own<br />
            <span className="script">backyard.</span>
          </motion.h1>
          <motion.p className="home__sub" {...rise(0.16)}>
            Upload a photo of your space, pick an MSpa, and watch it appear right where you'd put it. About a minute, no measuring required.
          </motion.p>
          <motion.div className="home__cta" {...rise(0.24)}>
            <button className="btn btn--primary btn--lg" onClick={handleGetStarted}>
              Start with your backyard
            </button>
          </motion.div>
          <motion.div className="home__steps" {...rise(0.32)}>
            <span><b>Your photo</b></span>
            <span className="home__steps-div" />
            <span><b>Your spa</b></span>
            <span className="home__steps-div" />
            <span><b>Your view</b></span>
          </motion.div>
        </div>

        <motion.div
          className="home__gallery"
          initial={reduce ? undefined : { opacity: 0, scale: 0.96 }}
          animate={reduce ? undefined : { opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="print-frame">
            <img className="home__print" src={HERO} alt="A golden-hour New Zealand backyard deck, ready for a spa" />
            <span className="home__print-cap">Your space, mounted like a print.</span>
          </div>
          <div className="home__filmstrip" aria-hidden="true">
            {STRIP.map((src) => (
              <img key={src} src={src} alt="" />
            ))}
          </div>
        </motion.div>
      </main>
    </div>
  )
}

export default HomePage
